<div class="layui-collapse" lay-accordion="">
  <div class="layui-colla-item">
    <h2 class="layui-colla-title">积分有哪些用途？</h2>
    <div class="layui-colla-content layui-show">
      <p>积分可在APP中购买VIP、放电、玩游戏、兑换座驾、查看来访记录等。</p>
    </div>
  </div>
  <div class="layui-colla-item">
    <h2 class="layui-colla-title">什么是魔术唤醒？</h2>
    <div class="layui-colla-content">
      <p>如果对方不可语聊时，选择使用魔术唤醒功能，我们会通过短信通知对方请求语聊，对方同意后可立即开启语聊。</p>
    </div>
  </div>
  <div class="layui-colla-item">
    <h2 class="layui-colla-title">更换头像、相册、昵称、个性签名、直播封面、直播主题为什么无法即时完成？</h2>
    <div class="layui-colla-content">
      <p>用户更换头像、相册、昵称、个性签名、直播封面、直播主题需人工审核后方可外显，因人工审核工作量较大，请耐心等待！</p>
    </div>
  </div>
  <div class="layui-colla-item">
    <h2 class="layui-colla-title">如何设置通话时间？</h2>
    <div class="layui-colla-content">
      <p>设置通话时间入口：“个人中心”-“设置”-“接听设置”。</p>
    </div>
  </div>
  <div class="layui-colla-item">
    <h2 class="layui-colla-title">为什么不可以通话？</h2>
    <div class="layui-colla-content">
      <p>
      1.如果您是给普通用户发起通话，那您的免费通话时长可能已用完，开通会员可增加免费时长。<br>
      2.如果您是给咨询师/专家发起通话，那可能是您的账户余额不足，请及时充值。<br>
      3.如果对方设置当前时段不可通话，您可以使用魔术唤醒，我们将通过短信的方式通知对方，如对方同意通话，即可接通。
      </p>
    </div>
  </div>
  <div class="layui-colla-item">
    <h2 class="layui-colla-title">如何绑定/更换手机号码？</h2>
    <div class="layui-colla-content">
      <p>您可以在“个人中心”-“设置”-“账号设置”中更换所绑定的电话号码。</p>
    </div>
  </div>
  <div class="layui-colla-item">
    <h2 class="layui-colla-title">微信充值为什么会限额？</h2>
    <div class="layui-colla-content">
      <p>微信充值限额是因为您所绑定的银行卡已达当日交易额度，如需继续充值，建议您换卡支付或者通过其他充值方式充值。</p>
    </div>
  </div>
  <div class="layui-colla-item">
    <h2 class="layui-colla-title">为什么会出现“对方账号异常”提醒？</h2>
    <div class="layui-colla-content">
      <p>对方的账号已被官方封禁。</p>
    </div>
  </div>
  <div class="layui-colla-item">
    <h2 class="layui-colla-title">为什么充值未到账？</h2>
    <div class="layui-colla-content">
      <p>请添加客服QQ：3210820541或拨打客服电话：0755-82669662 (分机8013) 进行沟通。</p>
    </div>
  </div>
  <div class="layui-colla-item">
    <h2 class="layui-colla-title">如何获取充值优惠？</h2>
    <div class="layui-colla-content">
      <p>请扫描下方二维码，关注微信公众号“考米语音社交”，我们会在公众号不定期上线充值优惠活动。</p>
      <img src="http://r.51callme.com/www/images/mobile-app/kaomi.png" style="width:200px;height: 200px;padding:10px"></img>
    </div>
  </div>
</div>